import React from 'react'

/**
 * 画像を表示するコンポーネント。`fit` prop でレンダリングモードを切り替える。
 *
 * - `fit='default'`: 指定アスペクト比（`aspectRatio`）の領域に object-contain で表示
 *   - width : height = 25 : 16 => height / width = 480 / 750 = 0.64 が基準
 *   - width : height = 28 : 33 => height / width = 990 / 840 = 1.178... が基準
 * - `fit='width-fit'`: 幅全体に引き伸ばし、高さは auto
 * - `fit='contain-natural'`: コンテナ（w-full h-full）を埋め、画像の自然なアスペクト比で
 *   object-contain 表示。`aspectRatio` prop は無視される。
 *   ポップアップや任意サイズ画像の表示に使用する。
 */
export const Image = ({
  src,
  alt = '',
  aspectRatio = '25/16',
  fit = 'default',
}: {
  src: string
  /** 画像の代替テキスト。装飾画像の場合は空文字（デフォルト）を指定する */
  alt?: string
  aspectRatio?: '25/16' | '28/33'
  fit?: 'default' | 'width-fit' | 'contain-natural'
}) => {
  if (fit === 'default') {
    return (
      <div className="relative w-full h-full flex items-center justify-center">
        <img
          src={src}
          alt={alt}
          className="max-w-full max-h-full w-full h-full object-contain"
          style={{ aspectRatio }}
        />
      </div>
    )
  }
  if (fit === 'width-fit') {
    return <img src={src} alt={alt} className="w-full h-auto" />
  }
  if (fit === 'contain-natural') {
    // aspectRatio prop は使用しない。コンテナの w-full h-full に対して object-contain で内接表示する。
    return (
      <div className="relative w-full h-full flex items-center justify-center">
        <img src={src} alt={alt} className="block w-full h-full object-contain" />
      </div>
    )
  }
  return null
}
